<template>
  <div>

    <b-row class="mt-2 mb-2">
      <b-col md="7">

        <div class="filter-group">
          <div class="d-flex justify-content-center">

            <label for="" style="margin-right: 10px; margin-top: 8px">De</label>
            <input type="date" class="form-control"  style="width: 40%; margin-right: 20px" v-model="filters.startDate">

            <label for="" style="margin-right: 10px; margin-top: 8px">Até</label>
            <input type="date" class="form-control"  style="width: 40%" v-model="filters.endDate">

          </div>
        </div>

      </b-col>

      <b-col md="2">
        <button type="button" class="btn btn-primary mb-0" style="width: 100%" @click="showAtraso()">Buscar</button>
      </b-col>

    </b-row>

    <hr>

    <b-row class="justify-content-between">
      <b-col md="12">

        <b-table
            striped
            hover
            bordered
            sort-icon-left
            show-empty
            :items="items"
            :fields="fields"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
            :current-page="currentPage"
            :per-page="perPage"
            thead-class="font-weight-bold"
        >

          <template #empty="totalRows">
              <h6 style="text-align: center">Nenhum resultado encontrado.</h6>
          </template>

          <!-- Formatar campo data -->
          <template #cell(contato)="data">
            {{ formTelefone(data.item.contato) }}
          </template>

          <!-- Formatar campo telefone -->
          <template #cell(created_at)="data">
            {{ moment(data.item.created_at).format('DD/MM/YYYY \à\\s HH:mm') }}
          </template>

          <template v-slot:cell(view-button)="{ item }">
            <span>
              <b-btn style="background-color: #1c869a" id="view-button" @click.prevent="getTextoAtraso(item.id)">
                   <i class="fas fa-eye fa-fw"></i>
              </b-btn>
            </span>
          </template>

        </b-table>

      </b-col>
    </b-row>

    <b-row class="justify-content-between">
      <b-col md="4">
        <b-form-group
            label="Registros por página"
            label-for="per-page-select"
            label-cols-md="6"
            label-align-sm="right"
            label-size="sm"
            class="mb-0 align-self-center"
        >
          <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="7" md="6" class="my-1">
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            size="md"
            class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>

    <dtModalAtrasoAten ref="dtModalAtrasoAten"/>
  </div>

</template>

<script>
import {mapMutations} from 'vuex'
import moment from 'moment';

export default {
  data() {
    return {
      moment: moment,
      sortDesc: false,
      fields: [
        { key: 'created_at', label: 'Data',  thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'contato',  thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'protocolo',  thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        { key: 'cidade', label: 'Cidade/UF',  thStyle: {backgroundColor: '#1c869a', color: '#ffffff'}, sortable: true },
        {
          key: 'view-button',
          label: 'Visualizar',
          sortable: true,
          class: 'text-center',
          thStyle: {backgroundColor: '#1c869a', color: '#ffffff', width: '100px'}
        }
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, { value: 100, text: "Ver mais" }],
      sortBy: '',
      sortDirection: 'desc',
      filter: null,
      filterOn: [],
      selectedFilter: 'data',
      filters: {
        startDate: '',
        endDate: '',
      },
      items: [],
      infoModal: {}
    }
  },
  methods : {
    ...mapMutations(['setLogChat']),

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    async getTextoAtraso(id){
      axios.get(`/solicitacoes/${id}/atrasos-atendimentos`).then(({data}) => {
        const infoModal =  {
          contato: this.formTelefone(data.contato),
          cnpj: data.cnpj,
          protocolo: data.protocolo,
          cidade: data.cidade,
          solicitacaoData: data.solicitacaoData,
          solicitacaoHora: data.solicitacaoHora,
          solicitacaoTexto: data.solicitacaoTexto,
          solicitacaoAssunto: data.solicitacaoAssunto,
          dataRazaoSocialCliente: data.dataRazaoSocialCliente,
          dataNomeFantasiaCliente: data.dataNomeFantasiaCliente,
          dataEnderecoCliente: data.dataEnderecoCliente,
          dataCEPCliente: data.dataCEPCliente,
          dataNomePonto: data.dataNomePonto,
          dataCodigoPonto: data.dataCodigoPonto,
          created_at: moment(data.created_at).format('DD/MM/YYYY \à\\s HH:mm')
        }
        this.setLogChat(infoModal);

        this.$refs.dtModalAtrasoAten.openModal();
      })
    },
    formTelefone(tel) {
      if(tel.substr(0,2) != '55'){
        return '+' + tel;
      }
      tel=tel.replace(/\D/g,"")
      tel=tel.replace(/^(\d)/,"+$1")
      tel=tel.replace(/(.{3})(\d)/,"$1($2")
      tel=tel.replace(/(.{6})(\d)/,"$1)$2")
      if(tel.length == 12) {
          tel=tel.replace(/(.{1})$/,"-$1")
      } else if (tel.length == 13) {
          tel=tel.replace(/(.{2})$/,"-$1")
      } else if (tel.length == 14) {
          tel=tel.replace(/(.{3})$/,"-$1")
      } else if (tel.length == 15) {
          tel=tel.replace(/(.{4})$/,"-$1")
      } else if (tel.length > 15) {
          tel=tel.replace(/(.{4})$/,"-$1")
      }
      tel=tel.replace("("," (");
      tel=tel.replace(")",") ");

      return tel;
    },
    getAtrasos(){
      this.items = []
      axios.get('solicitacoes/atrasos-atendimentos').then(({data}) => {
        if(data.length > 0){
          this.items = data;
          this.totalRows = data.length
        } 
      })
    },
  
    showAtraso() {
      axios.get('solicitacoes/atrasos-atendimentos', {params: {start: this.filters.startDate, end: this.filters.endDate}}).then(({data}) => {
        this.items = data;
        this.totalRows = data.length
      }).catch(error => {
        console.error(error)
      });
    },

    resetFilters(){
      this.filters = {
        startDate: '',
        endDate: '',
      }
    }

  },
  mounted() {
    this.getAtrasos()
    this.totalRows = this.items.length;
  },
  watch: {
    selectedFilter(){
      this.resetFilters()
    },
    attData(){
      this.totalRows = this.items.length
    }
  }

}
</script>

<style>
.bgModalHeader{
  background-color: #1c859a;
  color: #FFFFFF;
}
.modal-content{
  border-radius: 3rem;
}
</style>

